import { REHYDRATE } from 'redux-persist'
import { selectors } from '../common/bookmakersInfo';
import { actionTypes } from './events.actions';

function selectedBookmakerWatcher(oldState, newState) {
    const oldSelectedBookmaker = selectors.selectedBookmakerSelector(oldState);
    const newSelectedBookmaker = selectors.selectedBookmakerSelector(newState);
    if (oldSelectedBookmaker !== newSelectedBookmaker) {
        const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER_CHANGED', {
            detail: { bookmaker: newSelectedBookmaker },
        });
        document.dispatchEvent(betslipEvent);
    }
}

function applicationInitialized() {
    const betslipEvent = new CustomEvent('BETSLIP.INITIALIZED');
    document.dispatchEvent(betslipEvent);
}

export default function eventsMiddleware(store) {
    let initialized = false;
    let rehidrated = false;
    return next =>
        (action) => {
            if (action.type === actionTypes.SET_INITIALIZED) {
                initialized = true;
                if (rehidrated) {
                    applicationInitialized();
                }
            }
            const oldState = store.getState();
            const result = next(action);
            const newState = store.getState();
            if (initialized && rehidrated) {
                selectedBookmakerWatcher(oldState, newState);
            }
            if (action.type === REHYDRATE) {
                rehidrated = true;
                if (initialized) {
                    applicationInitialized();
                }
            }
            return result;
        };
}



// WEBPACK FOOTER //
// /src/js/App/events.middleware.js